// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Messages":"cq_a bhh_a bhh_w","Messages__hasSeen":"cq_b bhh_p"};